<template>
  <div>
    <h2 class="text-base font-bold text-gray-900 mb-3 leading-snug">
      Your HR architecture - review before you continue
    </h2>
    <p class="text-sm leading-relaxed text-gray-700 mb-6">
      These settings lock your HR architecture. Changes after setup
      require a data migration and support assistance.
    </p>

    <div class="review-summary mb-6">
      <div
        v-for="(row, index) in reviewRows"
        :key="row.label"
        class="flex items-center gap-4 py-4"
        :class="{ 'border-b border-gray-200': index < reviewRows.length - 1 }"
      >
        <div class="flex items-center gap-2 min-w-0">
          <span
            class="review-summary__bullet flex-shrink-0"
            aria-hidden="true"
          />
          <p class="text-sm font-bold text-gray-900 m-0 mb-1">
            {{ row.label }}
          </p>
        </div>

        <div class="min-w-0">
          <p class="text-sm text-gray-700 m-0 leading-relaxed">
            {{ row.value }}
          </p>
        </div>
      </div>
    </div>

    <label
      class="review-confirm-block flex gap-3 p-4 rounded-xl cursor-pointer transition-colors"
    >
      <input
        type="checkbox"
        class="sr-only"
        :checked="reviewConfirmed"
        @change="$emit('toggle', $event.target.checked)"
      />

      <span
        class="flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center mt-0.5"
        :class="
          reviewConfirmed ? 'option-check--on border-0' : 'border-gray-300 bg-white'
        "
      >
        <svg
          v-if="reviewConfirmed"
          class="w-3 h-3 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </span>

      <div class="min-w-0">
        <p class="text-sm font-bold m-0 leading-snug">
          I confirm these selections reflect how my organisation manages
          HR in practice
        </p>
        <p class="text-sm mt-1 m-0 leading-relaxed">
          If you are unsure, go back and review with your HR lead before
          confirming. These settings cannot be changed after setup
          without data migration.
        </p>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "OrgOnboardingStep2",
  props: {
    reviewRows: {
      type: Array,
      default: () => [],
    },
    reviewConfirmed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle"],
};
</script>

<style scoped>
.review-summary__bullet {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: var(--org-onboarding-accent, #f06431);
}

.review-confirm-block {
  background: #fbfbfb;
}
</style>

